import "@babel/polyfill";
import Vue from "vue";
import axios from "./modules/axios";
import "@/assets/style/style.scss";
import MobileMenu from "./components/mobile-menu.vue";
import NoShippingInfo from "./components/no-shipping-info.vue";

Vue.prototype.$http = axios;

const instances = [MobileMenu, NoShippingInfo];

instances.forEach((instance) => {
  const elements = Array.prototype.slice.call(document.querySelectorAll(instance.selector));

  elements.forEach(
    (el) =>
      new Vue({
        ...instance,
        el,
        // takes data attributes (data-*) on the root element and parses them as props
        propsData: Object.entries(el.dataset).reduce(
          (sum, [key, val]) => ({
            ...sum,
            get [key]() {
              try {
                return JSON.parse(val);
              } catch (err) {
                return val;
              }
            }
          }),
          {}
        )
      })
  );
});

let options = {
  thershold: 1.0,
  rootMagin: "0px",
  root: null
};
let callback = (entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.setAttribute("playsinline", "");
      entry.target.play();
    } else {
      entry.target.pause();
    }
  });
};
let observer = new IntersectionObserver(callback, options);
let videos = document.querySelectorAll(".observed-video");
Array.from(videos).forEach((video) => {
  observer.observe(video);
});
